import React from 'react';
import AbstractComponent from '../AbstractComponent';
import Form from '../layout/form/Form';
import ServiceNav from '../layout/nav/ServiceNav';
import NavTab from '../layout/nav/NavTab';
import ContentCadastro from '../layout/content/ContentCadastro';
import NotificacaoActionButton from './NotificacaoActionButton';
import DadosMensagem from './DadosMensagem';
import Aparelhos from './Aparelhos';

import NotificacaoService from '../../service/NotificacaoService';

import { getParam } from '../../helper/Url';
import { dataHoraAtual } from '../../helper/Formatar';

class NotificacaoCadastro extends AbstractComponent { 
    constructor(props) {
        super(props);

        this.state = {
            salvar: {
                disabled: true,
                name: 'Salvar'
            },

            erro: {
                message: '',
                code: 0
            },

            preload: false,            

            sucesso: false,    

            alterando: false,            

            modalErroMsg: {
                message: '',
                code: 0
            },            

            form: {
                uuid: '',
                ativo: 'Sim',                
                title: '',
                tipo_notificacao: '',
                body: '',
                click_action: '',
                icon: '',
                data_envio: undefined,
                prazo_limite_envio: undefined,
                agendado_para: undefined,                
                persistencia: {                    
                    data_criacao: dataHoraAtual(),
                    alterado_em: dataHoraAtual(),
                    criado_por: this.props.usuario.nome,
                    alterado_por: this.props.usuario.nome,
                },
                status: 'EM EDICAO',
                notificacao_aparelho: []                
            },

            erroForm: {                
                body: '',
                tipo_notificacao: ''                
            }
        }               

        this.nav = new ServiceNav();

        this.nav.addComponent(
            1,
            'dadosmensagem',
            'Dados da mensagem',            
            false,
            DadosMensagem,
            {
                usuario: this.props.usuario,
                form: this.state.form,
                erroForm: this.state.erroForm,                  
                onChange: (e) => this.onChange(e),
                onValidaLogo: () => this.onValidaLogo()
            }
        );

        this.nav.addComponent(
            2,
            'aparelhos',
            'Aparelhos',            
            false,
            Aparelhos,
            {
                usuario: this.props.usuario,
                visible: false,                
                form: this.state.form,
                erroForm: this.state.erroForm,                 
                compartilhada: (show) => this.showPage(2, show),
                dedicada: (show) => this.showPage(3, show),
                onUpdatePushAparelho: (notificacaoAparelho, index) => this.onUpdatePushAparelho(notificacaoAparelho, index),
            }
        );
    }

    readOnly() {
        let form = this.state.form;                         
                
        form.status = 'Aguardando Envio';

        this.setState({form: form});
    }

    onChange(e) {        
        var form = this.state.form;                         
                
        form[e.target.name] = e.target.value;

        var salvar = this.state.salvar;
        
        salvar.disabled = false;        

        this.setState({
            form: form,
            salvar: salvar
        });
    }      

    limparErroForm() {
        var erroForm = this.state.erroForm;

        erroForm.tipo_notificacao = '';
        erroForm.body = '';                

        this.nav.clearIndexErro();

        this.setState({
            erroForm: erroForm
        });        
    }

    canAtivar() {        
        var erroForm = this.state.erroForm;
        var erro = false; 

        if(this.state.alterando) {            
            if(this.state.form.notificacao_aparelho.length === 0) {
                erroForm.body = "Informe pelo menos 1 aparelho";                    
                erro = true;
            }
        }

        if(erro) {            
            this.nav.setIndexErro(1);

            this.setState({erroForm: erroForm});

            return false;
        }

        return true;
    }

    canSaveMensagem() {
        this.limparErroForm();

        var form = this.state.form;
        var erroForm = this.state.erroForm;
        var erro = false;    

        if(!form.tipo_notificacao) {
            erroForm.tipo_notificacao = "Informe o tipo de notificação";                   
            erro = true;
        }

        if(!form.body) {
            erroForm.body = "Informe o corpo da mensagem";                   
            erro = true;
        }         
    
        if(erro) {            
            this.nav.setIndexErro(0);
                    
            this.setState({erroForm: erroForm});

            return false;
        }        

        return true;
    }

    showPage(index, show) {
        const nav = this.nav.getMenu();
        const menu = nav[index];
        const props = menu.props;

        menu.props.visible = show;
        menu.props = props;

        nav.splice(index, 1, menu);

        this.nav.setMenu(nav);
    }    
    
    onSubmit(e) {        
        if(!this.canSaveMensagem())            
            return ;        
            
        var salvar = this.state.salvar;

        salvar.disabled = true;
        salvar.name = 'Aguarde...';

        this.setState({ 
            salvar: salvar,
            erro: {
                message: '',
                code: 0
            }
        });                         
        
        NotificacaoService.gravar(
            this.state.form 
        ).then(response => {
            var salvar = this.state.salvar;
        
            salvar.name = 'Salvar';

            this.showPage(1, true);            

            var form = this.state.form;

            form.uuid = response.data.uuid;

            this.setState({
                form: form,
                alterando: true,
                salvar: salvar,
                sucesso: true
            });            
        }).catch((erro) => {
            var salvar = this.state.salvar;

            salvar.disabled = false;
            salvar.name = 'Salvar';

            this.setState({
                erro: this.trataErro(erro),
                salvar: salvar
            });            
        });
    }    

    onUpdatePushAparelho(notificacaoAparelho, index) {        
        var form = this.state.form;        

        if(notificacaoAparelho === undefined) {
            form.notificacao_aparelho.splice(index, 1);

            this.setState({ form: form });   

            return ;
        }        

        if( Array.isArray(notificacaoAparelho) ) {
            notificacaoAparelho.forEach(element => {
                form.notificacao_aparelho.push(element);
            });
        
            this.setState({ form: form });        

            return ;
        }
        
        form.notificacao_aparelho.push(notificacaoAparelho);               

        this.setState({ form: form });        
    }

    componentDidMount() {
        const hash = getParam('hash');        
        
        if((hash === undefined)||(hash === null)||(hash === 0))
            return ;            
    
        this.setState({
            modalErroMsg: {
                message: '',
                code: 0
            },
            preload: true
        });

        NotificacaoService.load(hash).then(resposta => {                        
            let form = this.state.form;            

            form.uuid = resposta.data.uuid;
            form.ativo = resposta.data.ativo;
            form.id_cliente = resposta.data.id_cliente;            
            form.title = resposta.data.title;
            form.tipo_notificacao = resposta.data.tipo_notificacao;
            form.body = resposta.data.body;
            form.click_action = resposta.data.click_action;
            form.icon = resposta.data.icon;            
            form.data_envio = resposta.data.data_envio;
            form.prazo_limite_envio = resposta.data.prazo_limite_envio;
            form.agendado_para = resposta.data.agendado_para;
            form.status = resposta.data.status.toUpperCase();
            form.persistencia = resposta.data.persistencia;  
            
            if(resposta.data.notificacao_aparelho !== undefined)
                form.notificacao_aparelho = resposta.data.notificacao_aparelho;

            this.showPage(1);

            this.setState({
                form: form,
                modalErroMsg: {
                    message: '',
                    code: 0
                },
                preload: false,
                alterando: true                
            });                            
        }).catch(erro => {
            this.setState({
                modalErroMsg: this.trataErro(erro),
                preload: false
            });
        });        
    }

    render() {
        return(                                                                             
            <div>                
                <Form onSubmit={(e) => this.onSubmit(e)} id="form"> 
                    <input type="hidden" name="id" id="id_hiden" value={this.state.form.id}/>
                    <input type="hidden" name="title" id="title_hiden" value={this.state.form.title}/>
                    <input type="hidden" name="tipo_notificacao" id="tipo_notificacao" value={this.state.form.tipo_notificacao}/>
                    <input type="hidden" name="agendar_para" id="agendar_para_hiden" value={this.state.form.agendar_para}/>
                    <input type="hidden" name="prazo_limite_envio" id="prazo_limite_envio_hiden" value={this.state.form.prazo_limite_envio}/>
                    <input type="hidden" name="body" id="body_hiden" value={this.state.form.body}/>                    

                    <ContentCadastro 
                        title="Manutenção da Notificação"
                        history="notificacao"

                        preload={this.state.preload || this.props.preload}
                        sucesso={this.state.sucesso}
                        textoSucesso="Notificação salva com sucesso"
                        modalErroMsg={this.state.modalErroMsg}

                        salvar={this.state.salvar}    
                        salvarVisible={this.state.form.status === 'EM EDICAO'}

                        erro={this.state.erro}          
                                            
                        componentFooterCrud={ (props) => { return (
                            <NotificacaoActionButton 
                                uuid_notificacao={this.state.form.uuid} 
                                visible={((this.state.alterando)&&(this.state.form.status === 'EM EDICAO')&&(this.state.form.notificacao_aparelho.length > 0))}                                 
                                onReadOnly={() => this.readOnly()}
                                {...props} 
                            />
                        )}}

                        onSalvar="submit"                    
                        onSucesso={() => this.setState({sucesso: false})}
                        fecharModal={() => this.setState({modalErroMsg: this.finalizaErro(this.state.modalErroMsg)})}  
                        
                        route={(route) => this.props.route(route)}
                    >      
                        <NavTab
                            nav={this.nav.getMenu()}
                            indexErro={this.nav.getIndexErro()}                        
                        />
                    </ContentCadastro>            
                </Form>
            </div>
        )
    }
}

export default NotificacaoCadastro;